import { useEffect, useState } from "react";
import { Select, Space } from "antd";
import Flag from "react-world-flags";
import { getAllCountries } from "@/api/core";

interface CountryCodeSelectProps {
  field?: any;
  onSelectCountryCode: (value: string) => void;
  isDisabled?: boolean;
}

const CountryCodeSelect = ({
  field,
  onSelectCountryCode,
  isDisabled,
}: CountryCodeSelectProps) => {
  const [countryCodeList, setCountryCodeList] = useState([]);
  const [selectedOption, setSelectedOption] = useState<any>(null);

  const setCountryData = (data: any) => {
    return data.map((obj: any) => ({
      key: obj.id,
      value: `${obj.iso}:${obj.code}`,
      label: (
        <Space>
          <Flag code={obj.iso.toLowerCase()} className="h-4 w-4" />
          {obj.code} - {obj.iso}
        </Space>
      ),
      iso: obj.iso.toLowerCase(),
      name: obj.country,
      code: obj.code,
      ...obj,
    }));
  };

  useEffect(() => {
    const fetchOptions = async () => {
      const countries = await getAllCountries();
      const formattedData = setCountryData(countries.data.data);
      const usCountry = formattedData.filter((item) => item.iso === "US");
      setCountryCodeList(usCountry);
    };
    fetchOptions();
  }, []);

  useEffect(() => {
    if (field?.value && countryCodeList.length > 0) {
      if (field.value.includes(":")) {
        const selected = countryCodeList.find(
          (country) => country.value === field.value
        );
        setSelectedOption(selected);
      } else {
        const selected = countryCodeList.find(
          (country) => country.code === field.value
        );
        setSelectedOption(selected);
      }
    }
  }, [field, countryCodeList]);

  return (
    <Select
      value={selectedOption?.value || field?.value}
      onChange={(value) => {
        const selected = countryCodeList.find(
          (country) => country.value === value
        );
        if (selected) {
          const code = selected.code;
          onSelectCountryCode(code);
          setSelectedOption(selected);
        }
      }}
      optionFilterProp="label"
      showSearch
      style={{ width: "100%" }}
      placeholder="Country Code"
      optionLabelProp="label"
      options={countryCodeList}
      className="country-code-select h-10"
      popupMatchSelectWidth={true}
      listHeight={176}
      notFoundContent="No Country code found."
      defaultActiveFirstOption={false}
      filterOption={(input, option) =>
        option?.name?.toLowerCase().includes(input.toLowerCase()) ||
        option?.code?.toLowerCase().includes(input.toLowerCase())
      }
      allowClear
      onClear={() => {
        setSelectedOption(null);
        onSelectCountryCode("");
      }}
      disabled={isDisabled}
      size="middle"
    />
  );
};

export default CountryCodeSelect;
